import { IOption } from "interface";
import i18n from "locales/i18n";
import { dayOption } from "util/option";

export default function CalendarDay() {
  const langCd = i18n.language;
  return (
    <div className="month-day-wrap">
      <ul className="month-day left">
        {dayOption.map((day: any, index) => {
          return <li key={index}>{day[langCd as keyof IOption]}</li>;
        })}
      </ul>
      <ul className="month-day right">
        {dayOption.map((day: any, index) => {
          return <li key={index}>{day[langCd as keyof IOption]}</li>;
        })}
      </ul>
    </div>
  );
}
